import { ReactElement } from "react";

export default function IconStorage(): ReactElement {
  return (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_d_12543_10181)">
        <path
          d="M26 8H15C13.3431 8 12 9.34315 12 11V37C12 38.6569 13.3431 40 15 40H33C34.6569 40 36 38.6569 36 37V18L26 8Z"
          fill="url(#paint0_linear_12543_10181)"
        />
        <path
          d="M26.1768 7.82322C26.1299 7.77634 26.0663 7.75 26 7.75H15C13.2051 7.75 11.75 9.20507 11.75 11V37C11.75 38.7949 13.2051 40.25 15 40.25H33C34.7949 40.25 36.25 38.7949 36.25 37V18C36.25 17.9337 36.2237 17.8701 36.1768 17.8232L26.1768 7.82322Z"
          stroke="black"
          strokeOpacity="0.1"
          strokeWidth="0.5"
          strokeLinejoin="round"
        />
      </g>
      <g filter="url(#filter1_dd_12543_10181)">
        <path
          d="M35.8293 17.8293L26.1707 8.17071C26.1077 8.10771 26 8.15233 26 8.24142V15C26 16.6569 27.3431 18 29 18H35.7586C35.8477 18 35.8923 17.8923 35.8293 17.8293Z"
          fill="white"
        />
      </g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19 24C19 23.4477 19.4477 23 20 23H28C28.5523 23 29 23.4477 29 24V32C29 32.5523 28.5523 33 28 33H20C19.4477 33 19 32.5523 19 32V24ZM20 24H23.5V26H20V24ZM23.5 27H20V29H23.5V27ZM20 30H23.5V32H20V30ZM28 24H24.5V26H28V24ZM24.5 27H28V29H24.5V27ZM28 30H24.5V32H28V30Z"
        fill="#358CD9"
      />
      <defs>
        <filter
          id="filter0_d_12543_10181"
          x="5.5"
          y="2.5"
          width="37"
          height="45"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="3" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_12543_10181"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_12543_10181"
            result="shape"
          />
        </filter>
        <filter
          id="filter1_dd_12543_10181"
          x="23"
          y="6.1416"
          width="15.8588"
          height="15.8584"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="1.5" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_12543_10181"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="0.5" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
          />
          <feBlend
            mode="normal"
            in2="effect1_dropShadow_12543_10181"
            result="effect2_dropShadow_12543_10181"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect2_dropShadow_12543_10181"
            result="shape"
          />
        </filter>
        <linearGradient
          id="paint0_linear_12543_10181"
          x1="24"
          y1="8"
          x2="24"
          y2="40"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="#F9FBFC" />
        </linearGradient>
      </defs>
    </svg>
  );
}
